import { put, PutEffect } from 'redux-saga/effects';
import cloneDeep from 'lodash.clonedeep';

import { selElementBlendMode } from 'js/actionCreators/elementActions';
import { ExistingScribeModel, VSImageShapeOrTextElementModel } from 'js/types';
import { updateScribe } from 'js/actionCreators/scribeActions';

import getProjectFromPathname from './sagaHelpers/getProjectFromPathname';

export function* setElementBlendModeSaga(
  action: ReturnType<typeof selElementBlendMode>
): Generator<ReturnType<typeof getProjectFromPathname> | PutEffect, void, ExistingScribeModel | undefined> {
  const project = yield getProjectFromPathname();

  if (!project) return;

  const newProject = cloneDeep(project);
  const targetElements = newProject.elements.filter<VSImageShapeOrTextElementModel>(
    (el): el is VSImageShapeOrTextElementModel => el.type !== 'Camera' && action.payload.elementIds.includes(el.id)
  );
  targetElements.forEach(element => {
    element.blendMode = action.payload.blendMode;
  });

  yield put(updateScribe(newProject));
}
